"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RequiredIndicator = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const constants_1 = require("../../constants");
const translate_1 = require("../../translate");
const Indicator = styled_1.default.span((props) => {
    return {
        color: props.requiredByDefault ? constants_1.Color.DARKEST_MEDIUM_GREY : constants_1.Color.RED,
        fontSize: props.requiredByDefault ? constants_1.theme.font.size[6] : undefined,
        fontWeight: props.requiredByDefault
            ? constants_1.theme.font.weight.book
            : constants_1.theme.font.weight.bold,
    };
});
const RequiredIndicator = (props) => {
    const t = (0, translate_1.useTranslations)();
    const showIndicator = props.requiredByDefault
        ? !props.required
        : props.required;
    return showIndicator ? ((0, jsx_runtime_1.jsxs)(Indicator, { requiredByDefault: !!props.requiredByDefault, children: [' ', props.requiredByDefault ? `(${t.form.optional()})` : '*'] })) : null;
};
exports.RequiredIndicator = RequiredIndicator;
